import Timeline from "astrid-components/lib/components/Audio/Timeline";

import { parts } from "../state/parts";

import useParts from "./useParts";

export default function useScopeParts() {
	useParts();
	const scope = Timeline.useScope();

	return parts.scope(scope);
}
